import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["href"]

import {onMounted, ref} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'GoogleAccountSelector',
  props: ['googlePickerUrlGetAccounts', 'googlePickerUrlManageAccounts', 'i18n'],
  emits: ['setActiveGoogleAccount'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit
const activeGoogleAccount = ref(0)
const googleAccounts = ref([])

function changeGoogleAccount() {
    localStorage.setItem('eg-fileupload-googlephotosaccount-id', activeGoogleAccount.value)
    emit('setActiveGoogleAccount',activeGoogleAccount.value)
}

onMounted(async () => {
    await fetch(props.googlePickerUrlGetAccounts)
        .then((response) => response.json())
        .then((responseData) => {
            googleAccounts.value = responseData
        })
    const oldid = parseInt(localStorage.getItem('eg-fileupload-googlephotosaccount-id'));
    if (googleAccounts.value.some( account => account.id == oldid)) {
        activeGoogleAccount.value = oldid
    } else {
        activeGoogleAccount.value = googleAccounts.value[0].id
    }
    changeGoogleAccount()
})


return (_ctx: any,_cache: any) => {
  return (googleAccounts.value.length > 0)
    ? _withDirectives((_openBlock(), _createElementBlock("select", {
        key: 0,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeGoogleAccount).value = $event)),
        class: "form-select",
        onChange: changeGoogleAccount
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(googleAccounts.value, (value) => {
          return (_openBlock(), _createElementBlock("option", {
            key: value.id,
            value: value.id
          }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_1))
        }), 128 /* KEYED_FRAGMENT */))
      ], 544 /* NEED_HYDRATION, NEED_PATCH */)), [
        [_vModelSelect, activeGoogleAccount.value]
      ])
    : (_openBlock(), _createElementBlock("p", _hoisted_2, [
        _createTextVNode(_toDisplayString(__props.i18n.COM_EVENTGALLERY_EVENT_UPLOAD_NO_GOOGLE_ACCOUNTS) + " ", 1 /* TEXT */),
        _createElementVNode("a", { href: __props.googlePickerUrlManageAccounts }, _toDisplayString(__props.i18n.COM_EVENTGALLERY_EVENT_UPLOAD_MANAGE_GOOGLE_ACCOUNTS), 9 /* TEXT, PROPS */, _hoisted_3)
      ]))
}
}

})